module.exports = __webpack_public_path__ + "img/introductionToSafetyStudies.7cc4671b.jpg";